import { useFormContext, useFormField } from '@calendly/form';
import { FieldError } from '@calendly/form/parts';
import { I18n } from '@calendly/i18n';
import classNames from 'classnames';
import { useEffect, useCallback, forwardRef } from 'react';
import { FieldBlock, Label } from './styles';
import { useTextField } from '../hooks/use_text_field';
const styledInputCss = "sziyf33";
const StyledInput = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'input';
  return <Component ref={ref} {...restProps} className={classNames(styledInputCss, props.className)} />;
});
const labelInputWrapperCss = "l1di7bes";
const LabelInputWrapper = forwardRef((props, ref) => <div ref={ref} {...props} className={classNames(labelInputWrapperCss, props.className)} />);
export const EmailSubjectField = ({
  errorMessage,
  ...props
}) => {
  const [{
    name,
    value
  }] = useFormField(props);
  const fieldProps = useTextField(props);
  const {
    setFieldError,
    setFieldValue
  } = useFormContext();
  useEffect(() => {
    setFieldError(name, '');
  }, [name, setFieldError, value]);
  const onInputChange = useCallback(event => {
    const newValue = event.target.value;
    setFieldValue('subject', {
      ...value,
      plainText: newValue
    });
  }, [setFieldValue, value]);
  return <FieldBlock data-component="subject_field_block">
      <LabelInputWrapper>
        <Label htmlFor="subject">{I18n.t('publisher.contacts.share.email_form.subject')}</Label>
        <StyledInput {...fieldProps} id="subject" onChange={onInputChange} contentEditable value={value.plainText} type="text" onKeyDown={event => {
        if (event.key === 'Enter') {
          event.preventDefault();
        }
      }} />
      </LabelInputWrapper>
      <FieldError text={errorMessage} id={errorMessage} />
    </FieldBlock>;
};

require("./email_subject_field.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./email_subject_field.js");